import request from '@/config/axios'

export interface PriceInventoryCalendarVO {
  date: string
  price: number | null
  extraBedPrice: number
  totalCount: number
  availableCount: number
  lockedCount: number
  soldCount: number
}

export interface PriceInventorySaveVO {
  shopId: string | number
  spuId: string | number
  skuId?: string | number
  date: string
  price: number
  extraBedPrice: number
  totalCount: number
}

export const queryCalendar = (params: {
  shopId: string | number
  spuId: string | number
  startDate: string
  endDate: string
}) => request.get<PriceInventoryCalendarVO[]>({ url: '/hotel/price-inventory/calendar', params })

export const batchSet = (data: PriceInventorySaveVO[]) =>
  request.post({ url: '/hotel/price-inventory/batch-set', data })
